var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Activity',{attrs:{"imgsThis1":_vm.imgsThis1,"imgsThis2":_vm.imgsThis2,"images":_vm.images,"text":"Réalisation d’une œuvre avec une technique à base d’œuf  la TEMPERA."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }